import { useAuthStore } from '../../../components/Login/useAuthStore';

export function useLoginStatus() {
  const loginStatus = useAuthStore((state) => state.loginStatus);
  return loginStatus;
}
